import React from 'react'
import PropTypes from 'prop-types'
import Button from 'portal-modules/common/components/Button'
import RpModal from 'portal-modules/common/components/modals/rp-modal'
import { createMtomInterval } from 'portal-modules/renewals/redux/modules/renewals'
import { PRIVATE_ROOT } from 'portal-modules/common/constants/urls'
import { connect } from 'react-redux'
import { dismissAlertsByTypeByRef } from 'portal-modules/alerts-panel/redux/modules/alerts'
import { ALERT_TYPES } from 'portal-modules/alerts-panel/constants/types'

import styled from '@emotion/styled'

const StyledButton = styled(Button)`
  font-size: 16px;
  line-height: 1.5;
  margin: 0 4px 16px;
`
const StyledButtonDiv = styled('div')`
  display: flex;
  justify-content: center;
`

const MonthToMonthOfferModal = props => {
  const handleConfirm = () => {
    props.onClose()
    props.createMtomInterval(
      { lease_id: props.leaseId, offer_lease_id: props.offerLeaseId },
      () => {
        props.dismissAlertsByTypeByRef({
          refId: props.application_id,
          type: ALERT_TYPES.RENEWAL_OFFER,
        })
        props.history.push(PRIVATE_ROOT)
      },
    )
  }

  const { isLeaseAndRentWordReplaced } = props

  const leaseReplacedText = isLeaseAndRentWordReplaced
    ? __(
        'You have chosen to go month-to-month instead of renewing your housing agreement. In addition to being charged any applicable month-to-month rates, your renewal offer will be cancelled.  If you would like to renew in the future, please reach out to the office at your property.',
      )
    : __(
        'You have chosen to go month-to-month instead of renewing your lease. In addition to being charged any applicable month-to-month rates, your renewal offer will be cancelled.  If you would like to renew in the future, please reach out to the leasing office at your property.',
      )
  return (
    <RpModal
      {...props}
      title={__('Month-to-Month Selected')}
      footerContent={
        <StyledButtonDiv>
          <StyledButton appearance='secondary' onClick={handleConfirm}>
            {__('Confirm')}
          </StyledButton>
          <StyledButton appearance='primary' onClick={props.onClose}>
            {__('Cancel')}
          </StyledButton>
        </StyledButtonDiv>
      }
    >
      <span>{leaseReplacedText}</span>
    </RpModal>
  )
}

MonthToMonthOfferModal.propTypes = {
  createMtomInterval: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  leaseId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  offerLeaseId: PropTypes.number,
  dismissAlertsByTypeByRef: PropTypes.func.isRequired,
  application_id: PropTypes.number.isRequired,
  isLeaseAndRentWordReplaced: PropTypes.bool,
}

export default connect(
  ({
    user: { leaseId },
    settings,
    renewals: { application_id },
    productPermissions,
  }) => ({
    leaseId,
    offerLeaseId:
      settings && settings.renewal && settings.renewal.offer_lease_id,
    application_id,
    isLeaseAndRentWordReplaced:
      productPermissions?.replace_lease_and_rent || false,
  }),
  { createMtomInterval, dismissAlertsByTypeByRef },
)(MonthToMonthOfferModal)
